import { useSelector } from 'react-redux';

import { selectAccountSlug } from '@/redux/session/selectors';

import { useLeaveModal } from './useLeaveModal';
import { selectBrainId } from '../redux/selectors';

type EntityLink = { to: (entity: string) => string; goTo: (entity: string) => void };

export const useGoToEntity = (): EntityLink | null => {
  const leaveModal = useLeaveModal();
  const slug = useSelector(selectAccountSlug);
  const brainId = useSelector(selectBrainId);

  if (!slug || !brainId) {
    return null;
  }

  const to = (entity: string) => `/${slug}/ai-agents/${brainId}/workflows/entities/${entity}`;

  return { to, goTo: (entity: string) => leaveModal(to(entity)) };
};
